// extracted by mini-css-extract-plugin
module.exports = {"caption":"Caption-module--caption--hrrSq"};